import { useTranslation } from '@framework/i18n';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
const image = {
  url: require('../images/MiC_nextgenerationeu_POS_ORIZ.svg'),
};

const AdminLogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
`;

const LogoNextgenerationeuWrapper = styled.div`
  max-width: 100%;
  height: 40px;
  width: auto;
  display: flex;
  ${down('sm')} {
    height: 30px;
  }
`;
export interface ITopNextgenerationeuLogoProps {}

/**
 * Logo Nextgenerationeu lell'header dell'applicativo.
 */
export function TopNextgenerationeuLogo(props: ITopNextgenerationeuLogoProps) {
  const { t } = useTranslation();
  return (
    <LogoNextgenerationeuWrapper>
      <AdminLogoImg
        src={image.url}
        alt={t(
          'mic.logo-nextgenerationeu.alt',
          "Logo Finanziato dall'unione Europea - NextGenerationEU",
        )}
      />
    </LogoNextgenerationeuWrapper>
  );
}
